export const adTypes = [
    {
        key: '5',
        title: "激励视频"
    },
    {
        key: '2',
        title: "插屏"
    },
    {
        key: '4',
        title: "横幅"
    },
    {
        key: '1',
        title: "原生"
    },
    {
        key: '3',
        title: '开屏'
    },
    {
        key: '6',
        title: '积分墙'
    },
    {
        key: '8',
        title: '插播广告',
    }
]